import signatureRequestsQuery from '../../graphql/queries/esign/signatureRequestIndexQuery.graphql';
import usePaginatedQuery from '../usePaginatedQuery';

const dataPath = 'getAllSignatureRequestsForOwner';

const useSignatureRequests = (options = {}) =>
  usePaginatedQuery(signatureRequestsQuery, dataPath, options);

export default useSignatureRequests;
